
import React from "react";
import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";

interface IngredientCategoryProps {
  category: {
    name: string;
    items: string[];
  };
  ingredients: string[];
  excludedIngredients: string[];
  toggleIngredient: (ingredient: string) => void;
  toggleExcludedIngredient: (ingredient: string) => void;
  index: number;
  totalCategories: number;
}

const IngredientCategory: React.FC<IngredientCategoryProps> = ({
  category,
  ingredients,
  excludedIngredients,
  toggleIngredient,
  toggleExcludedIngredient,
  index,
  totalCategories
}) => {
  return (
    <div key={category.name} className="mb-3 last:mb-0">
      <p className="text-sm font-medium mb-1">{category.name}</p>
      <div className="flex flex-wrap gap-2 mb-2">
        {category.items.map((ingredient) => (
          <Badge
            key={ingredient}
            variant={ingredients.includes(ingredient) ? "default" : 
                   excludedIngredients.includes(ingredient) ? "destructive" : "outline"}
            className="cursor-pointer transition-colors"
            onClick={() => toggleIngredient(ingredient)}
            onContextMenu={(e) => {
              e.preventDefault();
              toggleExcludedIngredient(ingredient);
            }}
          >
            {ingredient}
          </Badge>
        ))}
      </div>
      {index < totalCategories - 1 && <Separator className="my-2" />}
    </div>
  );
};

export default IngredientCategory;
